/**
 * 유저 유입 경로 추적을 위해 세션 간 유지해야 할 URL 쿼리 파라미터 키 목록.
 *
 * Attribution = "이 유저가 어떤 채널/캠페인을 통해 유입되었는가?"
 *
 * 채널 유형:
 * - Paid Media: utm_source, utm_medium, utm_campaign, utm_term, utm_content
 * - Referral: referral_code
 * - Direct Outreach: tiktok_handle (크리에이터 직접 접촉)
 *
 * 이 목록에 포함된 키는 middleware에 의해 쿠키에 자동 저장되며,
 * useAttribution 훅을 통해 클라이언트에서 접근할 수 있습니다.
 */

// 1. 접두사 기반 키 (e.g., utm_source, utm_medium, ...)
export const ATTRIBUTION_PREFIXES = ['utm_'];

// 2. 개별 키 (e.g., ref, referrer, ...)
export const ATTRIBUTION_KEYS = [
  'ref',
  'referrer',
  'referral_code',
  'tiktok_handle', // Direct outreach channel identifier
];

// 3. 유입 경로 정보를 저장하는 쿠키의 이름
export const ATTRIBUTION_COOKIE_NAME = 'buffamin_attribution_params';
